import { genericPage, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
import { isCodiCanal } from 'utils/canals';

// /audio/id/embed/
const path = ['web', process.env.FOLDER_LAYOUTS, 'audio', 'embed'];
const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { id } = context.query;
    let path = ['web', process.env.FOLDER_LAYOUTS, 'audio', 'embed'];

    if (isCodiCanal(id)) {
        path = ['web', process.env.FOLDER_LAYOUTS, 'audio', 'embed', 'directe'];
    } else if (!Number.isInteger(parseInt(id))) {
        return {
            notFound: true
        };
    }

    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
